import React from 'react';
import {PaginationItem} from "../../pages/groups/group-container/main-table/pagination-item/PaginationItem";
import {ReactComponent as ArrayLeftIcon} from '../../../assets/main/groups/main-table/array-left.svg';
import {ReactComponent as ArrayRightIcon} from '../../../assets/main/groups/main-table/array-right.svg';

interface PaginationProps {
    currentPage: number;
    totalItems: number;
    itemsPerPage: number;
    paginate: (pageNumber: number) => void;
}


export const Pagination: React.FC<PaginationProps> = (
    {
        currentPage,
        totalItems,
        itemsPerPage,
        paginate,
    }
) => {
    return (
        <ul className="pager">
            <li className="prev">
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    paginate(currentPage - 1);
                }}>
                    <ArrayLeftIcon/>
                </a>
            </li>
            {Array.from({length: Math.ceil(totalItems / itemsPerPage)}).map((_, index) => {
                const pageNumber = index + 1;
                const isActive = index === currentPage - 1;

                return (
                    <PaginationItem
                        key={index}
                        pageNumber={pageNumber}
                        isActive={isActive}
                        onClick={() => paginate(pageNumber)}
                    />
                );
            })}
            <li className="next">
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    paginate(currentPage + 1);
                }}>
                    <ArrayRightIcon/>
                </a>
            </li>
        </ul>
    );
};

